import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import * as ROUTES from '@constants/routes';

import type { ObservationRecord } from '@models/observation';

import ObservationTracker from '../ObservationTracker/ObservationTracker';

const messages = defineMessages({
  title: {
    id: 'dashboardVitalSign.title',
    defaultMessage: 'Recent Vital Signs',
  },
  noVital: {
    id: 'dashboardVitalSign.noVital',
    defaultMessage:
      'To see vital sign metrics here, connect a device to your VITALL account by clicking Connect Device below or from within the Health Devices section.',
  },
  viewAll: {
    id: 'dashboard.metrics',
    defaultMessage: 'View All',
  },
});

function VitalSign({
  loading,
  observations,
}: {
  loading: boolean;
  observations: Record<string, ObservationRecord | null>;
}) {
  const { formatMessage } = useIntl();

  return (
    <ObservationTracker
      loading={loading}
      noData={formatMessage(messages.noVital)}
      observations={observations}
      route={ROUTES.VITAL_SIGNS}
      title={formatMessage(messages.title)}
      viewAll={formatMessage(messages.viewAll)}
    />
  );
}

export default VitalSign;
